import { render } from "./ManageHighlightListPage.vue?vue&type=template&id=7591f5b0&scoped=true"
import script from "./ManageHighlightListPage.vue?vue&type=script&lang=ts"
export * from "./ManageHighlightListPage.vue?vue&type=script&lang=ts"

import "./ManageHighlightListPage.vue?vue&type=style&index=0&id=7591f5b0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7591f5b0"

export default script